import { FC, useEffect, useRef, useState } from "react";
import { useAudio } from "../../contexts/AudioContext";

type Props = {
  audioUrl: string;
  size?: number;
  iconSize?: number;
  buttonClasses?: string;
};

export const PlayButton: FC<Props> = ({
  audioUrl,
  size,
  iconSize,
  buttonClasses = "",
}) => {
  const { currentPlayingRef, playAudio, stopAudio } = useAudio();
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    setIsPlaying(
      !!currentPlayingRef &&
        currentPlayingRef.current === audioRef.current &&
        !hasEnded
    );
  }, [currentPlayingRef, audioRef, isPlaying]);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        stopAudio();
        setIsPlaying(false);
      } else {
        playAudio(audioRef);
        setIsPlaying(true);
      }
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={togglePlay}
        className={[
          buttonClasses,
          size ? `w-${size} h-${size}` : "w-10 h-10",
          "inline-flex items-center justify-center bg-rust-500 hover:bg-rust-600 rounded-full text-white transition-colors duration-200",
        ].join(" ")}
      >
        {isPlaying ? (
          <svg
            className={iconSize ? `w-${iconSize} h-${iconSize}` : "w-6 h-6"}
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
          </svg>
        ) : (
          <svg
            className={[
              iconSize ? `w-${iconSize} h-${iconSize}` : "w-6 h-6",
              "ml-0.5",
            ].join(" ")}
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
        )}
      </button>

      <audio
        ref={audioRef}
        preload="metadata"
        onEnded={() => {
          setIsPlaying(false);
          setHasEnded(true);
        }}
        onError={() => setIsPlaying(false)}
      >
        <source src={audioUrl} type="audio/mpeg" />
      </audio>
    </>
  );
};
